"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ApplyNowLink", {
  enumerable: true,
  get: function get() {
    return _applyNowLink["default"];
  }
});
Object.defineProperty(exports, "FinishType", {
  enumerable: true,
  get: function get() {
    return _finishType["default"];
  }
});
Object.defineProperty(exports, "LinkType", {
  enumerable: true,
  get: function get() {
    return _linkType["default"];
  }
});
Object.defineProperty(exports, "Monetizable", {
  enumerable: true,
  get: function get() {
    return _monetizable["default"];
  }
});
exports["default"] = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.regexp.replace");

var _values2 = _interopRequireDefault(require("lodash/values"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Lock = _interopRequireDefault(require("@nerdwallet/react-icon/gizmo/Lock"));

var _tracking = require("@nerdwallet/nw-client-lib/tracking");

var _reactButtonShort = _interopRequireDefault(require("@nerdwallet/react-button-short"));

var _currency = require("@nerdwallet/currency");

var _classes = _interopRequireDefault(require("@nerdwallet/base-styles/classes"));

var _applyNowLink = _interopRequireDefault(require("./apply-now-link"));

var _applyNowModule = _interopRequireDefault(require("./apply-now.module.css"));

var _finishType = _interopRequireDefault(require("./finish-type"));

var _linkType = _interopRequireDefault(require("./link-type"));

var _monetizable = _interopRequireDefault(require("./monetizable"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function getAnnotationText(_ref) {
  var _ref$issuer = _ref.issuer,
      issuer = _ref$issuer === void 0 ? '' : _ref$issuer,
      _ref$payPerCall = _ref.payPerCall,
      payPerCall = _ref$payPerCall === void 0 ? '' : _ref$payPerCall;
  var wordForWebsite = issuer && issuer.toLowerCase() === 'citibank' ? 'application' : 'website';
  var phoneText = payPerCall ? ', or call ' : '';
  return "on ".concat(issuer, "'s ").concat(wordForWebsite).concat(phoneText);
}

var ApplyNow = /*#__PURE__*/function (_React$Component) {
  _inherits(ApplyNow, _React$Component);

  var _super = _createSuper(ApplyNow);

  function ApplyNow() {
    _classCallCheck(this, ApplyNow);

    return _super.apply(this, arguments);
  }

  _createClass(ApplyNow, [{
    key: "getElementInteractionProps",
    value: function getElementInteractionProps() {
      return {
        type: 'CLICK',
        elementCategory: 'link',
        sectionCategory: 'call-to-apply',
        elementContent: this.props.pay_per_call,
        elementName: this.props.id,
        elementPosition: this.props.productPosition,
        sectionPosition: this.props.sectionPosition,
        pageNumber: this.props.pageNumber
      };
    }
  }, {
    key: "getPhoneCTA",
    value: function getPhoneCTA() {
      if (!this.props.pay_per_call) {
        return null;
      }

      var phoneCTA = /*#__PURE__*/_react["default"].createElement(_currency.Link, {
        className: (0, _classes["default"])('nowrap'),
        href: "tel:".concat(this.props.pay_per_call.replace(/\D/g, ''))
      }, this.props.pay_per_call);

      return this.props.logImpression ? /*#__PURE__*/_react["default"].createElement(_tracking.ElementImpressionInteraction, this.getElementInteractionProps(), phoneCTA) : phoneCTA;
    }
  }, {
    key: "getAnnotation",
    value: function getAnnotation() {
      if (this.props.disableAnnotation) {
        return null;
      }

      var text = this.props.annotationText || getAnnotationText({
        issuer: this.props.issuer,
        payPerCall: this.props.pay_per_call
      });
      var phoneCTA = this.getPhoneCTA();
      var annotationClassName = (0, _classnames["default"])(['annotation', // Here for backwards compatibility, should not be used
      (0, _classes["default"])(['margin-top-1', 'text-align-center'])]);
      return /*#__PURE__*/_react["default"].createElement(_currency.Text, {
        className: annotationClassName,
        color: "neutral-darker",
        small: true
      }, text, phoneCTA);
    }
  }, {
    key: "applyText",
    value: function applyText() {
      var _this$props = this.props,
          issuer = _this$props.issuer,
          issuerNameApply = _this$props.issuerNameApply,
          text = _this$props.text;
      var content = 'Apply Now';

      if (text) {
        content = text;
      } else if (issuerNameApply) {
        content = "Apply on ".concat(issuer);
      }

      return /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classes["default"])('margin-right-1'),
        dangerouslySetInnerHTML: {
          __html: content
        } // eslint-disable-line react/no-danger

      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          showIcon = _this$props2.showIcon,
          icon = _this$props2.icon,
          otherProps = _objectWithoutProperties(_this$props2, ["className", "showIcon", "icon"]);

      var containerClassName = (0, _classnames["default"])([className, 'apply-now' // Here for backwards compatibility, should not be used
      ]);
      var buttonClassName = (0, _classnames["default"])([(0, _classes["default"])('width-100'), (0, _classes["default"])('text-align-center')]);
      var iconElement = showIcon ? icon || /*#__PURE__*/_react["default"].createElement(_Lock["default"], {
        textAligned: true,
        className: _applyNowModule["default"].icon
      }) : null;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: containerClassName
      }, /*#__PURE__*/_react["default"].createElement(_applyNowLink["default"], _extends({
        component: _reactButtonShort["default"]
      }, otherProps, {
        className: buttonClassName
      }), this.applyText(), iconElement), this.getAnnotation());
    }
  }]);

  return ApplyNow;
}(_react["default"].Component);
/**
 * This is a union of information required for
 * - rendering the apply-now button.
 * - firing the click event from the interstitial-client.
 * - firing the BetaProductShoppingFinish event from the interstitial-client.
 *
 * @see https://github.com/NerdWallet/schemas/blob/master/protobuf/src/event/BetaProductShoppingFinish.proto#L52
 */
// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


exports["default"] = ApplyNow;
ApplyNow.propTypes = {
  // An object containing extra properties for BetaProductShoppingFinish (which has a field called additional_attributes).
  additionalAttributes: _propTypes["default"].object,
  // eslint-disable-line react/forbid-prop-types
  // By default we put an annotation saying "On issuer's website" under the button, but you can override that by using this prop.
  annotationText: _propTypes["default"].string,
  className: _propTypes["default"].string,
  // If you want no annotation-text under the apply button.
  disableAnnotation: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  // BetaProductShoppingFinish:finish_type
  finishType: _propTypes["default"].oneOf((0, _values2["default"])(_finishType["default"])),
  hasPrequalified: _propTypes["default"].bool,
  icon: _propTypes["default"].node,
  // Used for impression identification. If there are multiple apply nows for the same product on a page, this should be unique for each one.
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  // CC (credit-cards vertical) uses a cc-specific impression event. Set this to true for that behavior.
  isCC: _propTypes["default"].bool,
  issuer: _propTypes["default"].string,
  // Some issuers prefer "Apply on <issuer>" instead of "Apply Now". Use this bool to signal one or the other (false by default).
  issuerNameApply: _propTypes["default"].bool,
  // The apply now link. obtained from the marketplace object.
  link: _propTypes["default"].string.isRequired,
  // What type of control was the link on? See link-type.js for more info.
  linkType: _propTypes["default"].oneOf((0, _values2["default"])(_linkType["default"])),
  logImpression: _propTypes["default"].bool,
  // Is this a monetizable link?
  monetizable: _propTypes["default"].oneOf((0, _values2["default"])(_monetizable["default"])),
  // Whether the link should open in a new window, true by default
  newWindow: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  // For a multi-page interface (like cc tool), which page did this card appear on?
  pageNumber: _propTypes["default"].number,
  // Some issuer's let you call a number to apply for the card. Obtained from Marketplace.
  pay_per_call: _propTypes["default"].string,
  // UI treatment. Primary button?
  primary: _propTypes["default"].bool,
  // Why was this card displayed to the user?
  productDisplayDriver: _propTypes["default"].string,
  // The ID of a financial product
  productId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  // For lists of card. Which position was this card at?
  productPosition: _propTypes["default"].number,
  referringUrl: _propTypes["default"].string,
  rel: _propTypes["default"].string,
  // UI treatment. Secondary button?
  secondary: _propTypes["default"].bool,
  // For a section interface (like BCC)
  sectionName: _propTypes["default"].string,
  // Where was the section located on the page
  sectionPosition: _propTypes["default"].number,
  // If you want show the icon in the ApplyNow button
  showIcon: _propTypes["default"].bool,
  // UI treatment. Tertiary button?
  tertiary: _propTypes["default"].bool,
  // If you want to put something other than ApplyNow
  text: _propTypes["default"].string
}; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

ApplyNow.defaultProps = {
  additionalAttributes: null,
  annotationText: null,
  className: null,
  disableAnnotation: false,
  disabled: false,
  finishType: _finishType["default"].EXTERNAL_APPLICATION,
  hasPrequalified: false,
  icon: null,
  id: null,
  isCC: false,
  issuer: null,
  issuerNameApply: false,
  linkType: _linkType["default"].applyNowButton,
  logImpression: true,
  monetizable: null,
  newWindow: true,
  onClick: function onClick() {},
  pageNumber: null,
  pay_per_call: null,
  primary: true,
  productDisplayDriver: null,
  productId: null,
  productPosition: null,
  referringUrl: null,
  rel: null,
  secondary: false,
  sectionName: null,
  sectionPosition: null,
  showIcon: true,
  tertiary: false,
  text: ''
};